import axios from 'axios';


export const BildirgeApi = () => {

  return axios.post('https://milensoft.com/api/trf/getPetition.php',{
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
